import axios from 'axios';

const { PRD_API } = window.uniteus;

const prdApiAxios = axios.create({
  baseURL: PRD_API,
});

export default prdApiAxios;
